module.exports = __webpack_public_path__ + "img/pres-03.4a410a63.png";